module.exports = __webpack_public_path__ + "img/financiamiento-be.0344d3db.svg";